import React from 'react';
import JobOpeningHeader from '../components/CareersComponents/JobOpeningComponents/JobOpeningHeader';
import JobOpeningLayout from '../components/CareersComponents/JobOpeningComponents/JobOpeningLayout';
import CareersFooter from '../components/CareersComponents/CareersFooter';

const JobOpening = () => (
  <>
    <JobOpeningHeader />
    <JobOpeningLayout />
    <CareersFooter />
  </>
);

export default JobOpening;
